import { defineMessage } from 'services/localization';

export const messages = {
    workflowApprovalStepEmptyDurationH3: defineMessage('set_a_decision_due_date_for_approvers'),
    workflowReviewStepEmptyDurationH3: defineMessage('set_a_decision_due_date_for_reviewers'),
    workflowStepDurationH3: defineMessage('the_decision_due_date_for_this_step_is_in'),
    durationDaysPlural: defineMessage('count_plural_one_d_other_d'),
    durationHoursPlural: defineMessage('count_plural_one_h_other_h'),
    typeLabelNotSet: defineMessage('not_set_1'),
    typeLabelBasedOnSubmission: defineMessage('based_on_submission'),
    typeLabelBasedOnApproval: defineMessage('based_on_approval'),
    typeLabelBasedOnReview: defineMessage('based_on_the_start_of_the_review'),
};
